<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p [innerHTML]="data.message"></p>
@if( data.challengeString ) {
  <p class="danger">To proceed, first type {{data.challengeString}} into the box below.</p>
  <input matInput value="" class="danger" #challenge>
}
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">{{data.no}}</button>
  <button mat-button color="primary" (click)="onYesClick()" [disabled]="yesDisabled">{{data.yes}}</button>
</div>